import React, { useState } from "react";
import { Modal, Button, Container, Card } from "react-bootstrap"; // 從 react-bootstrap 導入 Modal
import pictureMapping from "../../utils/pictureMapping";
const FoundItem = (props) => {
  const image = pictureMapping[props.productCode.split("-")[0]];
  const now = new Date();
const formattedDate = now.toLocaleDateString('zh-TW', { year: 'numeric', month: '2-digit', day: '2-digit' });
  return (
    <>
      <Modal show={true} onClick={props.handleClose} centered>
        <Modal.Header
          closeButton
          style={{ borderBottom: "none" }}
        ></Modal.Header>
        <Modal.Body>
          <Container
            fluid
            className="d-flex flex-column justify-content-center align-items-center"
          >
            <p className="h1">
              <b>查詢到以下產品</b>
            </p>
            <Card
              style={{ height: "40vh", width: "40vh" }}
              className="shadow-sm p-4"
            >
              <Card.Img
                variant="top"
                src={image}
                style={{ height: "70%", objectFit: "contain" }}
              />
              <Card.Text className="text-center">
                <p className="h2"><b>{props.productCode}</b></p>
                <p>
                  <b style={{ color: "#20958F" }}>
                    {props.type} - {props.model}
                  </b>
                </p>
              </Card.Text>
            </Card>
            <p style={{ color: "#C1C1C1" }} className="m-3">
              <b>新增日期: {formattedDate}</b>
            </p>
            <Button
              className="btn-custom-green"
              style={{ width: "200px" }}
              onClick={props.api}
            >
              確定加入產品
            </Button>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default FoundItem;
